<footer class="footer">
  <p class="footer-text">
    desenvolvido por <a href="http://linkedin.com/in/bruno.romeiro" target="_blank">brunoromeiro</a>
  </p>

</footer>
